import React from "react";
import PropTypes from "prop-types";

import AddButton from "components/school_money/AddButton";
import RemoveButton from "components/school_money/RemoveButton";

/**
 * Displays either an add or a remove button, depending on the value is
 *   the isAdded prop
 */
export default class AddOrRemoveButton extends React.Component {
  
  static propTypes = {
    cssBlockName: PropTypes.string.isRequired,
    isAdded: PropTypes.bool.isRequired,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired
  }
  
  render() {
    const { cssBlockName, isAdded, onAdd, onRemove } = this.props;
    if (isAdded) {
      return <RemoveButton className={`${cssBlockName}__remove-button`} onClick={onRemove} />
    }
    return <AddButton className={`${cssBlockName}__add-button`} onClick={onAdd} />
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/AddOrRemoveButton.js